import type { Answer, ScoringCategory } from '@/types';
import type { ProductScoringConfig } from '@/types/product';

export function generateRecommendation(
  category: ScoringCategory,
  answers: Answer[],
  percentage: number,
  maps: ProductScoringConfig['recommendationMaps']
): string {
  const specificRecommendations: string[] = [];

  for (const answer of answers) {
    const questionId = answer.questionId;
    const value = answer.value;

    if (maps.specific[questionId]) {
      const valueKey = String(value);
      const recommendation = maps.specific[questionId][valueKey];

      if (recommendation && answer.score === 0) {
        specificRecommendations.push(recommendation);
      }
    }
  }

  if (specificRecommendations.length > 0) {
    return specificRecommendations[0];
  }

  const generalRec = maps.general[category];
  if (!generalRec) return '';
  if (percentage < 40) return generalRec.low;
  if (percentage < 70) return generalRec.medium;
  return generalRec.high;
}

export function generateInsightText(
  _indicator: string,
  marketValue: number,
  companyValue: number
): { insight: 'above_average' | 'within_expected' | 'below_average'; text: string } {
  const ratio = companyValue / marketValue;

  if (ratio >= 1.1) {
    return {
      insight: 'above_average',
      text: `Acima da média do mercado em ${Math.round((ratio - 1) * 100)}%`
    };
  } else if (ratio >= 0.9) {
    return {
      insight: 'within_expected',
      text: 'Dentro da média do mercado'
    };
  } else {
    return {
      insight: 'below_average',
      text: `Abaixo da média do mercado em ${Math.round((1 - ratio) * 100)}%`
    };
  }
}
